import styled, { keyframes } from 'styled-components';
import { Link } from 'react-router-dom';

const slideIn = keyframes`
    0% {
        right: -100%;
        left: 100%;
    }
    100% {
        right: 0;
        left: 0;
    }
`;

const slideOut = keyframes`
    0% {
        right: 0;
        left: 0;
    }
    100% {
        right: -100%;
        left: 100%;
    }
`;

export const Share = styled.span`
    width: calc(100vw * (44 / 375));
    height: calc(100vw * (44 / 375));
    display: flex;
    justify-content: center;
    align-items: center;
    
    &:last-child {
        margin-right: calc(100vw * (4 / 375));
    }
`
export const More = styled.span`
    width: calc(100vw * (44 / 375));
    height: calc(100vw * (44 / 375));
    display: flex;
    justify-content: center;
    align-items: center;
`

export const ButtonIcon = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;

export const TopInner = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    background: #fff;
    z-index: 200;
    width: 100%;
    height: calc(100vw*(51/375));
    display: flex;
    align-items: center;
    // padding: 0 calc(100vw*(17/375));

    &.slide_on {
        animation : ${({animation}) => animation === true ? slideIn : 'none'} .2s;
    }
    &.slide_out {
        animation : ${({animation}) => animation === true ? slideOut : 'none'} .2s;
    }
`

export const TitleTxt = styled.h1`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    // width: 80%;
    text-align: center;
    font-size: calc(100vw * (16 / 375));
    font-weight: 500;
`;

export const Title = styled.div`
    flex: 1 1 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    // width: 80%;
    font-size: calc(100vw*(16/375));
    font-weight: 500;
    letter-spacing: 0.32px;
    // margin-left: calc(100vw*(131.2/375));
    overflow: hidden;
`

export const BackButtonarea = styled.div`
    ${({width}) => width ? `width: ${width}px;` : ''}
`;

export const Back = styled.span`
    width: calc(100vw * (44 / 375));
    height: calc(100vw * (44 / 375));
    display: flex;
    justify-content: center;
    align-items: center;
`

export const Buttonarea = styled.div`
    flex: 0 1 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    ${({width}) => width ? `width: ${width}px;` : ''}
`;
//${({width}) => width ? `width:${width};`: null} 
export const CloseBtnArea = styled.div`

`;
export const CloseBtnWrapper = styled.span`
    display: flex;
    width: calc(100vw*(44/375));
    height: calc(100vw*(44/375));
    justify-content: center;
    align-items: center;
    margin-right: calc(100vw*(4/375));
`
export const CompleteBtn = styled.span`
    font-weight: bold;
    font-size: calc(100vw*(24/375));
    line-height: calc(100vw*(24/375));
    color: #FFCF19;    
`;
export const DisabledCompleteBtn = styled(CompleteBtn)`
    color: #BCBDBF;
`;
export const ExitBtn = styled.span` 
    position: relative;
    display: inline-block;
    height: calc(100vw*(19/375));
    width: calc(100vw*(18/375));
`
export const ExitBtnImg = styled.img``;

export const BellLink = styled(Link)`
    position: relative;
    width: calc(100vw * (44 / 375));
    height: calc(100vw * (44 / 375));
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const Alarm = styled.span`
  position: absolute;
  right: 0;
  top: 0;
  display: inline-block;
  width: calc(100vw * (9 / 375));
  height: calc(100vw * (9 / 375));
  background-color: #de0000;
  border-radius: 50%;
`;

export const MatchingButtonBlock = styled.div`
    // display: flex;
    // align-items: center;
    // width: 100%;
    &:last-child {
        margin-right: calc(100vw * (4 / 375));
    }
`;

export const MatchingBtn = styled.span`
    display:block;
    width: calc(100vw * (24 / 375));
    height: calc(100vw * (24 / 375));
    margin-right: calc(100vw * (20 / 375));
`;

export const IconImg = styled.img`
    width: calc(100vw * (24 / 375));
    height: calc(100vw * (24 / 375));
    object-fit: contain;
`;